import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, ...props }, ref) => {
  const handleFocus = (e) => {
    // For numeric inputs, select contents on focus so any existing value
    // (including the default 0) is replaced on the first keystroke instead
    // of appending. Select synchronously (covers programmatic / fast focus)
    // AND defer once more so mouse-click caret positioning (which fires
    // AFTER focus on real clicks) doesn't collapse the selection.
    if (type === "number") {
      const target = e.target;
      try { target.select(); } catch (_) { /* no-op */ }
      setTimeout(() => { try { target.select(); } catch (_) { /* no-op */ } }, 0);
    }
    if (typeof onFocus === "function") onFocus(e);
  };
  return (
    <input
      type={type}
      onFocus={handleFocus}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
